

import { PoStatusEnum } from '@shahi-analytics/shared-models';
import { PrimaryGeneratedColumn, Entity, Column, CreateDateColumn, UpdateDateColumn, VersionColumn, Index } from 'typeorm';
import { CommonFieldsModel } from './common-fields.model';

@Entity('m_schedule')
export class ScheduleEntity extends CommonFieldsModel{
    @PrimaryGeneratedColumn('increment',{
        name:'id'
    })
    id: number;

    @Column('mediumint', {
        nullable: false,
        name: 'po_header_id'
    })
    poHeaderId: number;

    @Column('mediumint', {
        nullable: false,
        name: 'po_line_id'
    })
    poLineId: number;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'style'
    })
    style: string;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'color'
    })
    color: string;

    @Column('varchar', {
        nullable: false,
        length: 15,
        name: 'schedule'
    })
    schedule: string;

    @Column('mediumint', {
        nullable: false,
        name: 'quantity'
    })
    quantity: number;

    @Column('varchar', {
        nullable: false,
        length: 60,
        name: 'destination'
    })
    destination: string;

    @Column('date', {
        nullable: false,
        // length: 20,
        name: 'delivery_date'
    })
    deliveryDate: string;

    @Column('datetime', {
        nullable: false,
        name: 'start_date'
    })
    startDate: string;

    @Column('datetime', {
        nullable: false,
        name: 'end_date'
    })
    endDate: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'po_status'
    })
    poStatus: PoStatusEnum;

}

